import React from 'react';
import RouterWrap from "./Router";
import "../assets/scss/GlobalStyles.scss";
// import RouterWrap from "./Router";

function App() {
  return (
    <div className="wrapper">
        <RouterWrap/>
    </div>
  )
}

export default App;
